import React, { Component, useState, useEffect } from "react";
import { useOutletContext } from "react-router";
import { withRouter } from "../common/with-router";
import http from "../http-common";
import ReportService from "../services/report.service"

const ReportsSessionsAttendance = () => {
  const token = window.sessionStorage.getItem("token");
  const baseURL = http.defaults.baseURL + "/reports";
  const sessionDate = useOutletContext();
  const [attendance, setAttendance] = useState(null);

  useEffect(() => {
    ReportService.listAttendance(sessionDate)
    .then(resp => {
      setAttendance(convertAttendanceToTable(resp.data.attendance));
    })
    .catch(handleError);
  }, [sessionDate]);

  const handleError = e => {
    if (e.response?.status === 403) {
      this.navigate("/login");
    }
  };

  const convertAttendanceToTable = attendance => {
    if (attendance.length === 0) {
      return [];
    }
    const table = [];
    const total = {name: null, attended: 0, notAttended: 0, pending: 0}
    var row = null;
    for (const att of attendance) {
      const name = att.name;
      if ((row === null) || (name !== row.name)) {
        if (row !== null) {
          total.attended += row.attended;
          total.notAttended += row.notAttended;
          total.pending += row.pending;
          table.push(row);
        }
        row = {name: att.name, attended: 0, notAttended: 0, pending: 0};
      }
      if (att.attended === 1) {
        row.attended += att.count;
      } else if (att.attended === 0) {
        row.notAttended += att.count;
      } else {
        row.pending += att.count;
      }
    }
    total.attended += row.attended;
    total.notAttended += row.notAttended;
    total.pending += row.pending;
    table.push(row);
    table.push(total);
    return table;
  };

  return (
    <div className="mb-3 table-responsive">
      <table className="table table-striped has-totals">
        <thead>
          <tr>
            <th>Branch</th>
            <th className="text-center">Attended</th>
            <th className="text-center">Not Attended</th>
            <th className="text-center">Pending</th>
            <th className="text-center">Total</th>
          </tr>
        </thead>
        <tbody>
          {attendance === null && (
            <tr>
              <td colSpan="5">Loading...</td>
            </tr>
          )}
          {attendance?.length === 0 && (
            <tr>
              <td colSpan="5">No signups</td>
            </tr>
          )}
          {attendance?.map((att, index) => (
            <tr key={index}>
              <td>{att.name === null ? "Total" : att.name}</td>
              <td className="text-center">{att.attended}</td>
              <td className="text-center">{att.notAttended}</td>
              <td className="text-center">{att.pending}</td>
              <td className="text-center">{att.attended + att.notAttended + att.pending}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

}

export default withRouter(ReportsSessionsAttendance);
